module.exports = __webpack_public_path__ + "img/eps_pi_ch.e9a16ccd.png";